import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import SecurazeToolForm from "./SecurazeToolForm";
import { CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import { parseURL } from "../../sc-utilities";
import * as actions from './store/securazeToolsActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";
import { CancelToken } from 'axios';

const SecurazeToolEdit = props => {
    const { activeCustomerID, loadSecurazeTool, translations, securazeTool, loadSecurazeToolInit, updateSecurazeTool, permissions } = props;
    const [editData, setEditData] = useState({ loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            await loadSecurazeTool({ ActiveCustomerID: activeCustomerID, SecurazeToolID: parseURL(window.location.href).tools }, { cancelToken: requestToken.token })
            setEditData({ loadingData: false });
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
            loadSecurazeToolInit();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleSubmit = async data => {
        let formData = { ...data };
        formData['CustomerID'] = activeCustomerID;
        let result = await updateSecurazeTool({ ...formData, ActiveCustomerID: activeCustomerID, SecurazeToolID: parseURL(window.location.href).tools });
        if (result) {
            History.goBack()
        }
    };

    let initialValues = {
        ToolName:  securazeTool ? securazeTool.ToolName : '',
        Status: securazeTool ? securazeTool.Status : '',
        ForAllCustomers: securazeTool && securazeTool.CustomerID === null ? true : false,
    };

    let formSettings = {
        Validation: {
            ToolName: Yup.string().required("Required"),
            Status: Yup.string().required("Required"),
            ForAllCustomers: Yup.bool().required("Required"),
        },
        FormTitle:translations['edit_securaze_tool'] || "Edit securaze tool",
        ButtonSubmit: hasPermission(permissions, 'securaze_tool_save') ? {
            Title: translations["save"] || "SAVE"
        } : null,
    };

    return (
        !editData.loadingData ?
            <SecurazeToolForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
                edit={true}
                fileName={{edit: true}}
            /> :
            <CircularProgress />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        securazeTool:state.exportImport.securazeTools.loaded,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateSecurazeTool: data => dispatch(actions.editSecurazeTool(data)),
        loadSecurazeTool: (data, options) => dispatch(actions.loadSecurazeTool(data, options)),
        loadSecurazeToolInit: () => dispatch(actions.loadSecurazeToolInit()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SecurazeToolEdit);
